import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

import acceuil from '../media/acceuil.jpg';
import salleDeSoins from '../media/salle_de_soins.jpg';
import salleDattente from '../media/salledattenet.jpg';
import salleDattente2 from '../media/salledattente2.jpg';
import vue from '../media/vue.jpg';
import banniereClose from '../media/banniere_close.jpg';

const images = [
 // { src: acceuil, alt: 'Accueil du cabinet' },
  { src: salleDeSoins, alt: 'Salle de soins' },
  { src: salleDattente, alt: 'Salle d\'attente' },
  { src: salleDattente2, alt: 'Salle d\'attente - Vue 2' },
  { src: vue, alt: 'Vue du cabinet' },
  { src: banniereClose, alt: 'Bannière - Vue rapprochée' },
];

const Gallery: React.FC = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImg, setLightboxImg] = useState<{src: string, alt: string} | null>(null);

  return (
    <section className="w-full bg-white pt-28 sm:pt-24 md:pt-32 pb-16">
      <h2 className="section-title text-accent text-center mb-8 text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight drop-shadow-lg">Découvrez notre cabinet en images</h2>
      <div className="mx-auto px-4 sm:px-6 lg:px-8" style={{ maxWidth: '96rem' }}>
        <Swiper
          modules={[Navigation, Pagination, EffectFade, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          effect="fade"
          loop
          autoplay={{ delay: 4000, disableOnInteraction: true }}
          className="rounded-3xl shadow-elegant overflow-hidden"
          style={{ minHeight: 500, height: '100%' }}
        >
          {images.map((img, idx) => (
            <SwiperSlide key={idx}>
              <img
                src={img.src}
                alt={img.alt}
                className={`w-full h-[400px] md:h-[550px] object-cover object-center bg-gray-100 transition-transform duration-500 hover:scale-102 cursor-pointer ${img.src.includes('drapeau') ? 'px-20 md:px-48' : (['carte_visite', 'chaise_dentiste'].some(name => img.src.includes(name)) ? 'px-12 md:px-32' : '')}`}
                loading="lazy"
                onClick={() => { setLightboxOpen(true); setLightboxImg(img); }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        {lightboxOpen && lightboxImg && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 transition-opacity"
            onClick={() => setLightboxOpen(false)}
            tabIndex={-1}
            onKeyDown={e => { if (e.key === 'Escape') setLightboxOpen(false); }}
          >
            <img
              src={lightboxImg.src}
              alt={lightboxImg.alt}
              className="max-w-full max-h-[90vh] rounded-xl shadow-2xl border-4 border-white"
              onClick={e => e.stopPropagation()}
            />
            <button
              className="absolute top-6 right-8 text-white text-4xl font-bold bg-black bg-opacity-40 rounded-full px-4 py-2 hover:bg-opacity-70 transition"
              onClick={() => setLightboxOpen(false)}
              aria-label="Fermer"
              style={{zIndex: 60}}
            >
              &times;
            </button>
          </div>
        )}
        <style>{`
          .swiper-button-next, .swiper-button-prev {
            width: 1.5rem !important;
            height: 1.5rem !important;
            min-width: 0 !important;
            min-height: 0 !important;
            font-size: 1rem !important;
            border-radius: 9999px;
            background: rgba(0,0,0,0.25);
            color: white;
            transition: background 0.2s;
          }
          .swiper-button-next:hover, .swiper-button-prev:hover {
            background: rgba(0,0,0,0.5);
          }
          .swiper-button-next::after, .swiper-button-prev::after {
            font-size: 1.15rem !important;
          }
        `}</style>
      </div>
    </section>
  );
};

export default Gallery; 